export default class Cache{

    constructor(){
        this.cached = []
    }

    get(id){
        let cachedElement = this.cached.find(el => el.id == id)

        if(cachedElement == null){
            return null
        }

        return cachedElement.value;
    }

    has(id){
        return this.cached.find(el => el.id == id) != null
    }

    add(id, value){
        this.cached.push({id,value})
    }
}